import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const values = [
  { icon: 'ri-graduation-cap-fill', title: 'Formally Educated', desc: 'Our owner holds a degree in landscaping — one of the few Florida contractors who brings true academic expertise and depth of knowledge to every single project.' },
  { icon: 'ri-heart-fill', title: 'Passion-Driven', desc: "We're not just doing a job — we're crafting the outdoor space you've always envisioned. That dedication shows in the details others overlook." },
  { icon: 'ri-shield-check-fill', title: 'Licensed & Insured', desc: 'Fully licensed and insured for your complete peace of mind. We operate with total professionalism, transparency, and accountability.' },
  { icon: 'ri-group-fill', title: 'Community-Rooted', desc: 'Proudly serving Volusia and Flagler County — our neighbors are our customers, and we treat every property as if it were our own.' },
];

const gallery = [
  {
    src: 'https://public.readdy.ai/ai/img_res/e0995a653698fb73d309adacb6831f8b.jpg',
    label: 'Custom Paver Patio',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20white%20vinyl%20fence%20installation%20luxury%20Florida%20residential%20property%20lush%20manicured%20lawn%20upscale%20neighborhood%20premium&width=600&height=480&seq=dippels-about-g2&orientation=landscape',
    label: 'Premium Fence Install',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=luxury%20outdoor%20landscape%20lighting%20night%20Florida%20home%20pathway%20uplighting%20warm%20amber%20glow%20elegant%20garden%20premium%20design&width=600&height=480&seq=dippels-about-g3&orientation=landscape',
    label: 'Architectural Lighting',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=luxury%20residential%20landscape%20installation%20Florida%20tropical%20planting%20lush%20sod%20lawn%20vibrant%20green%20premium%20curb%20appeal%20professional&width=600&height=480&seq=dippels-about-g4&orientation=landscape',
    label: 'Full Landscape Installation',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=premium%20custom%20shed%20storage%20building%20luxury%20Florida%20backyard%20elegant%20design%20professional%20quality%20construction%20manicured%20lawn&width=600&height=480&seq=dippels-about-g5&orientation=landscape',
    label: 'Custom Shed Build',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=luxury%20outdoor%20transformation%20complete%20backyard%20renovation%20Florida%20premium%20paver%20patio%20landscaping%20lighting%20fence%20upscale&width=600&height=480&seq=dippels-about-g6&orientation=landscape',
    label: 'Complete Outdoor Transformation',
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        {/* Cinematic Hero */}
        <section className="relative overflow-hidden" style={{ minHeight: '520px' }}>
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=luxury%20outdoor%20landscape%20design%20Florida%20premium%20residential%20backyard%20paver%20patio%20lush%20tropical%20garden%20elegant%20cinematic%20golden%20evening%20light%20upscale%20sophisticated&width=1920&height=800&seq=dippels-about-hero&orientation=landscape"
              alt="About Dippel's Outdoor Services — Florida"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/35"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          </div>
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-gold to-transparent opacity-60"></div>

          <div className="relative z-10 max-w-4xl mx-auto px-6 py-36">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-gold"></div>
              <span className="text-gold text-[11px] font-semibold tracking-[0.28em] uppercase">Our Story</span>
            </div>
            <h1 className="font-serif text-white font-bold leading-tight mb-5" style={{ fontSize: 'clamp(38px, 4.5vw, 60px)' }}>
              Crafting Exceptional Outdoor<br />
              <em className="text-gold not-italic">Spaces in Florida</em>
            </h1>
            <p className="text-white/60 text-base leading-relaxed max-w-lg">
              Family-owned. Expert-led. Community-focused. Proudly serving Volusia &amp; Flagler County with degree-backed craftsmanship and uncompromising quality.
            </p>
          </div>
        </section>

        {/* Trust strip */}
        <section className="bg-charcoal border-b border-white/8 py-0">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/8">
              {[
                { icon: 'ri-star-fill', value: '5-Star', label: 'Google Rated', accent: true },
                { icon: 'ri-graduation-cap-fill', value: 'Degree', label: 'in Landscaping', accent: false },
                { icon: 'ri-shield-check-fill', value: 'Licensed', label: '& Fully Insured', accent: true },
                { icon: 'ri-map-pin-2-fill', value: '6 Cities', label: 'Served in Florida', accent: false },
              ].map((s, i) => (
                <div key={i} className="flex items-center gap-4 px-8 py-6">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 ${s.accent ? 'bg-gold/15 text-gold' : 'bg-forest/20 text-forest-light'}`}>
                    <i className={`${s.icon} text-base`}></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{s.value}</p>
                    <p className="text-white/45 text-xs">{s.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="bg-white py-28 px-6">
          <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-5 flex items-center gap-3">
                <span className="h-px w-8 bg-gold inline-block"></span>
                About Dippel's
              </p>
              <h2 className="font-serif text-charcoal font-bold leading-tight mb-6" style={{ fontSize: 'clamp(30px, 3vw, 44px)' }}>
                Born From a Passion for<br />
                <em className="not-italic text-forest">Outdoor Excellence</em>
              </h2>
              <p className="text-charcoal-muted leading-relaxed mb-5 text-[15px]">
                Dippel's Outdoor Services was founded with a clear mission: to bring professional-grade landscaping and outdoor construction to homeowners across Florida's east coast who deserve better than average results.
              </p>
              <p className="text-charcoal-muted leading-relaxed mb-5 text-[15px]">
                Our owner — a formally educated landscape professional — built this company on the belief that true craftsmanship requires both deep knowledge and genuine dedication. From the first fence post to the final paver stone, every project reflects that standard.
              </p>
              <p className="text-charcoal-muted leading-relaxed mb-10 text-[15px]">
                Today, Dippel's proudly serves homeowners throughout Palm Coast, Ormond Beach, Daytona Beach, Port Orange, New Smyrna Beach, and Edgewater — delivering outdoor transformations that increase property value and enhance daily living.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 bg-charcoal text-white font-semibold px-8 py-4 rounded-full hover:bg-forest transition-colors whitespace-nowrap"
                >
                  Request a Design Consultation
                </Link>
                <a
                  href="tel:3863014399"
                  className="inline-flex items-center justify-center gap-2 border border-charcoal/20 text-charcoal font-semibold px-8 py-4 rounded-full hover:bg-stone transition-colors whitespace-nowrap"
                >
                  <i className="ri-phone-fill text-gold"></i>
                  (386) 301-4399
                </a>
              </div>
            </div>
            <div className="relative">
              <div className="w-full h-[540px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20outdoor%20craftsman%20luxury%20Florida%20landscape%20installation%20skilled%20worker%20premium%20garden%20project%20high-end%20quality%20lush%20tropical%20residential&width=800&height=900&seq=dippels-about-story&orientation=portrait"
                  alt="Dippel's Outdoor Services Florida — professional craftsmanship"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Floating info card */}
              <div className="absolute -bottom-5 -right-4 bg-charcoal text-white rounded-xl p-5 max-w-xs">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-graduation-cap-fill text-gold"></i>
                  <span className="text-white text-sm font-semibold">Degree-Backed Expertise</span>
                </div>
                <p className="text-white/50 text-xs leading-relaxed">Our owner holds a formal degree in landscaping — bringing academic-level knowledge to every project.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="bg-stone py-24 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-14">
              <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-4 flex items-center gap-3 justify-center">
                <span className="h-px w-8 bg-gold inline-block"></span>
                Our Values
              </p>
              <h2 className="font-serif text-charcoal font-bold" style={{ fontSize: 'clamp(30px, 3vw, 44px)' }}>
                What Sets Dippel's Apart
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
              {values.map((v, i) => (
                <div key={i} className="bg-white rounded-2xl p-7 border border-stone-dark hover:border-forest/20 transition-all hover:-translate-y-1 duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-forest/10 rounded-xl mb-5">
                    <i className={`${v.icon} text-forest text-xl`}></i>
                  </div>
                  <h3 className="font-serif text-xl text-charcoal font-semibold mb-3">{v.title}</h3>
                  <p className="text-charcoal-muted text-sm leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery */}
        <section className="bg-white py-24 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
              <div>
                <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-4 flex items-center gap-3">
                  <span className="h-px w-8 bg-gold inline-block"></span>
                  Project Gallery
                </p>
                <h2 className="font-serif text-charcoal font-bold" style={{ fontSize: 'clamp(28px, 2.8vw, 40px)' }}>
                  Work We're Proud Of
                </h2>
              </div>
              <Link
                to="/services"
                className="inline-flex items-center gap-2 border border-charcoal/20 text-charcoal text-sm font-semibold px-6 py-3 rounded-full hover:bg-charcoal hover:text-white transition-all whitespace-nowrap"
              >
                View All Services <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {gallery.map((item, i) => (
                <div key={i} className="group relative w-full h-64 rounded-xl overflow-hidden cursor-pointer">
                  <img
                    src={item.src}
                    alt={`${item.label} — Dippel's Outdoor Services Florida`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-600"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                    <p className="text-white font-serif font-semibold text-sm">{item.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="relative py-24 px-6 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=luxury%20outdoor%20living%20space%20night%20premium%20Florida%20home%20elegant%20landscape%20lighting%20paver%20patio%20cinematic%20moody%20warm%20amber%20sophisticated%20upscale&width=1920&height=700&seq=dippels-about-cta&orientation=landscape"
              alt="Dippel's Outdoor Services — Florida premium outdoor design"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/65 to-black/45"></div>
          </div>
          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="h-px w-10 bg-gold"></div>
              <span className="text-gold text-[11px] font-semibold tracking-[0.28em] uppercase">Get Started</span>
              <div className="h-px w-10 bg-gold"></div>
            </div>
            <h2 className="font-serif text-white font-bold mb-6" style={{ fontSize: 'clamp(32px, 3.5vw, 50px)' }}>
              Let&apos;s Build Something<br />
              <em className="text-gold not-italic">You&apos;ll Love</em>
            </h2>
            <p className="text-white/60 text-base leading-relaxed mb-10 max-w-lg mx-auto">
              Contact Dippel's Outdoor Services today for a free, no-obligation design consultation for your Florida property.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-gold text-charcoal font-bold px-10 py-4 rounded-full hover:bg-gold-light transition-colors whitespace-nowrap"
              >
                <i className="ri-pencil-ruler-2-line"></i>
                Request a Design Consultation
              </Link>
              <a
                href="tel:3863014399"
                className="inline-flex items-center justify-center gap-2 border border-white/30 text-white font-semibold px-9 py-4 rounded-full hover:border-white/60 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill text-gold"></i>
                (386) 301-4399
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
